import { CollectionType } from '../../../../data-layer/collections/service';
import { DataTestId } from '../../../../ui/layout/DataTestIdWrapper';
import { TabsValue } from '../constants';

export const buildBloggerTabs = (businessId: string, tabsHidden?: boolean) => {
    if (!businessId || tabsHidden) {
        return [];
    }

    return [
        {
            value: TabsValue.POSTS,
            link: `/profile/${businessId}`,
            label: 'Посты',
            dataTestId: DataTestId.BUSINESS_DETAILS_TAB_POSTS,
        },
        {
            value: TabsValue.COLLECTIONS,
            link: `/profile/${businessId}/collections`,
            label: 'Коллекции',
            dataTestId: DataTestId.BUSINESS_DETAILS_TAB_COLLECTIONS,
        },
    ];
};

export const buildBloggerTabsWideProfile = (
    businessId: string,
    showSubcategories?: boolean,
    hasSavedCollections?: boolean,
    tabsHidden?: boolean,
) => {
    if (!businessId || (tabsHidden && !showSubcategories)) {
        return [];
    }

    if (showSubcategories) {
        const tabs = [
            {
                value: TabsValue.POSTS,
                link: `/profile/${businessId}`,
                label: 'Опубликованные посты',
                dataTestId: DataTestId.BUSINESS_DETAILS_TAB_POSTS,
            },
            {
                value: TabsValue.MODERATION,
                link: `/profile/${businessId}/moderation`,
                label: 'Все посты',
                dataTestId: DataTestId.BUSINESS_DETAILS_TAB_MODERATION,
            },
        ];

        if (tabsHidden) {
            return tabs;
        }

        tabs.push({
            value: TabsValue.COLLECTIONS,
            link: `/profile/${businessId}/collections`,
            label: 'Коллекции',
            dataTestId: DataTestId.BUSINESS_DETAILS_TAB_COLLECTIONS,
        });

        if (hasSavedCollections) {
            tabs.push({
                value: TabsValue.SAVED_COLLECTIONS,
                link: `/profile/${businessId}/collections?collectionType=saved`,
                label: 'Сохраненные коллекции',
                dataTestId: DataTestId.BUSINESS_DETAILS_TAB_SAVED_COLLECTIONS,
            });
        }

        return tabs;
    }

    return [
        {
            value: TabsValue.POSTS,
            link: `/profile/${businessId}`,
            label: 'Посты',
            dataTestId: DataTestId.BUSINESS_DETAILS_TAB_POSTS,
        },
        {
            value: TabsValue.COLLECTIONS,
            link: `/profile/${businessId}/collections`,
            label: 'Коллекции',
            dataTestId: DataTestId.BUSINESS_DETAILS_TAB_COLLECTIONS,
        },
    ];
};

export const buildSubcategories = (businessId: string, tabsValue: TabsValue) => {
    if (!businessId) {
        return [];
    }

    if (tabsValue === TabsValue.COLLECTIONS) {
        return [
            {
                value: CollectionType.CREATED,
                link: `/profile/${businessId}/collections`,
                label: 'Созданные',
                dataTestId: DataTestId.BUSINESS_DETAILS_TAB_CREATED,
            },
            {
                value: CollectionType.SAVED,
                link: `/profile/${businessId}/collections?collectionType=saved`,
                label: 'Сохраненные',
                dataTestId: DataTestId.BUSINESS_DETAILS_TAB_SAVED,
            },
        ];
    }

    if (tabsValue === TabsValue.POSTS) {
        return [
            {
                value: TabsValue.POSTS,
                link: `/profile/${businessId}`,
                label: 'Опубликованные посты',
                dataTestId: DataTestId.BUSINESS_DETAILS_TAB_POSTS,
            },
            {
                value: TabsValue.MODERATION,
                link: `/profile/${businessId}/moderation`,
                label: 'Все посты',
                dataTestId: DataTestId.BUSINESS_DETAILS_TAB_MODERATION,
            },
        ];
    }

    return [];
};
